/* eslint-disable @typescript-eslint/no-unused-vars */
import { SYNC_BEHAVIOUR_MODES } from '@components/sources/visualizer/mappingScreens/visualMapping';

abstract class SyncBehaviourModeCategory {
  showServerSucceeded = (isSyncing: boolean, succeeded: number) => true;

  docLinkDescription = '';
}

class Upsert extends SyncBehaviourModeCategory {
  docLinkDescription =
    'Upsert supports insertion of new records and updates to the existing records, while syncing data to the destination.';

  override showServerSucceeded = (isSyncing: boolean, succeeded: number) =>
    !isSyncing || Boolean(succeeded);
}
class Mirror extends SyncBehaviourModeCategory {
  docLinkDescription =
    'This mode mirrors the source by keeping the destination data the same as the source data.';
}

class DefaultFullSync extends SyncBehaviourModeCategory {}

export default (type?: string) => {
  switch (type) {
    case SYNC_BEHAVIOUR_MODES.UPSERT:
      return new Upsert();
    case SYNC_BEHAVIOUR_MODES.MIRROR:
      return new Mirror();
    default:
      return new DefaultFullSync();
  }
};
